import "core-js/modules/es.array.push.js";
import { ref, onMounted, reactive, getCurrentInstance, computed, watch, nextTick } from 'vue';
import { Chart } from '@antv/g2';
import { useI18n } from "vue-i18n";
import SvgIcon from "../components/SvgIcon.vue";
import { debounce, transform } from 'lodash-es';
import dayjs from "dayjs";
import util from "@/util/util";
import { useRouter, useRoute } from "vue-router";
import { DownCircleOutlined } from "@ant-design/icons-vue";

import { ElNotification, ElLoading } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/notification/style/css';
import 'element-plus/es/components/loading/style/css';
export default {
  name: "ScreeenManage",
  components: {
    DownCircleOutlined,
    SvgIcon
  },
  setup() {
    const {
      t,
      locale
    } = useI18n();
    const {
      proxy
    } = getCurrentInstance();
    const activeKey = ref('1');
    const propChart1 = ref(null);
    const propChart2 = ref(null);
    const propChart3 = ref(null);
    const screenChart1 = ref(null);
    const screenChart2 = ref(null);
    const screenChart3 = ref(null);
    const searchKeyword = ref("");
    const searchKeyword2 = ref("");
    const storeTable = ref(null);
    const storeTable2 = ref(null);
    const imageList = ref(null);
    const router = useRouter();
    const route = useRoute();
    const isScreen = route.query.isScreen;
    const dateValue = ref(null);
    const dateValue2 = ref(null);
    const deviceOnlineStatus = ref(null);
    // 在组件/全局作用域声明变量
    let chart1, chart2, chart3, chart4, chart5, chart6;
    const initChart = container => {
      return new Chart({
        container,
        autoFit: true
      });
    };
    const segmentedData = computed(() => [{
      label: t('screenManage.view'),
      value: 'view'
    }, {
      label: t('screenManage.list'),
      value: 'list'
    }]);
    const segmentedValue = ref('view');
    const chartData = computed(() => [{
      label: t('screenManage.pieChart'),
      value: 'pie'
    }, {
      label: t('screenManage.barChart'),
      value: 'bar'
    }]);
    const chartValue = ref('pie');
    const screenData = reactive({
      screenType: [],
      screenList: [],
      screenList2: [],
      cityList: [],
      screenTypeList: [],
      screenDeviceStatMsg: null,
      storeTypeIds: [],
      storeType: [],
      storeTypeIds2: [],
      storeType2: [],
      screenVendorList: [],
      venderId2: null,
      indeterminate: false,
      indeterminate2: false,
      storeLocationCount: null,
      dailyCount: [],
      vendorStoreLocationCount: [],
      pingStoreLocationCount: [],
      storeLocationCountPing: null,
      dailyCountPing: []
    });
    const open = ref(false);
    const storeLoading = ref(false);
    const currentYearMonth = ref('');
    const sixMonthsAgoYearMonth = ref('');
    const checkAll = ref(true);
    const checkAll2 = ref(true);
    const uploadFilePopoverVisible = ref(false);
    const uploadFilePopoverVisible1 = ref(false);
    const renderChart1 = async () => {
      if (!chart1) {
        chart1 = initChart(propChart1.value);
      } else {
        chart1.clear();
      }
      const value = screenData.storeLocationCount; // 852
      const now = new Date();
      let data = [];
      for (let i = 11; i >= 0; i--) {
        const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
        data.push({
          date: d,
          dailyCount: value,
          color: "total"
        });
      }
      chart1.data(data).encode("x", "date") // ✅ 保持日期为数值比例轴
      .encode("y", "dailyCount").encode("color", "color").scale("x", {
        type: "time",
        // ✅ 使用时间比例轴
        range: [0, 1],
        nice: true
      }).scale("y", {
        type: "linear",
        domain: [0, 1500],
        range: [1, 0]
      }).scale("color", {
        domain: ["total"],
        range: ["#056CFC"]
      });

      // ✅ 只显示月份标签（自定义labelFormatter）
      chart1.axis("x", {
        autoRotate: false,
        // 禁止自动旋转
        grid: true,
        labelFontSize: 10,
        title: null,
        gridStroke: "#000",
        gridLineWidth: 1,
        gridLineDash: [0, 0],
        label: {
          autoRotate: false,
          rotate: 0,
          // 0度横排
          style: {
            textAlign: 'center',
            fontSize: 10
          }
        },
        labelFormatter: val => {
          const d = new Date(val);
          const year = d.getFullYear();
          const month = (d.getMonth() + 1).toString().padStart(2, '0'); // 补零
          return `${year}.${month}`;
        },
        style: {
          textAlign: 'center',
          // 可选，文字居中
          fontSize: 6
        }
      });
      chart1.axis("y", {
        grid: true,
        labelFontSize: 10,
        title: null,
        gridStroke: "#000",
        gridLineWidth: 1,
        gridLineDash: [0, 0]
      });
      chart1.line().label({
        text: "",
        style: {
          dx: 20,
          dy: 20,
          fill: "#333"
        }
      }).style({
        lineWidth: 2
      }).animate("enter", {
        type: "pathIn",
        duration: 1000
      });

      // chart1
      //   .point()
      //   .style("fill", "white")
      //   .style("lineWidth", 2)
      //   .encode("size", 5)
      //   .tooltip(false);

      chart1.legend(false);

      // ✅ 自定义 tooltip，展示 activityData.videoTaskName
      chart1.interaction("tooltip", {
        render: (e, {
          title,
          items
        }) => {
          // 找到当前点的数据对象
          const rawData = data.find(d => new Date(d.videoTaskBeginDate).getTime() === new Date(title).getTime());

          // 拼接任务名
          const taskList = rawData?.activityData?.map(a => `<div style="color:#333">• ${a.videoTaskName}</div>`).join("") || "<div>无任务</div>";
          return `
            <div style="padding: 8px 12px; background: #fff; width:220px; font-size:12px;">
              <div style="margin-bottom: 6px; color:#909090;">${title.split(' ')[0]}</div>
              <div style="display: flex;justify-content: space-between;margin-bottom:6px;">
                <div style="display:flex;align-items: center;">
                  <span style="display: inline-block;width: 5px;height: 5px;background: #056CFC;margin-right:5px;border-radius:50%"></span>
                  屏幕总数
                </div>
                <div>${items[0].value}</div>
              </div>
            </div>
          `;
        }
      });
      try {
        chart1.render();
      } catch (e) {
        console.log(e);
      }
    };
    const renderChart2 = async () => {
      if (!chart2) {
        console.log('chart2走上');
        chart2 = initChart(propChart2.value);
      } else {
        console.log('chart2走下');
        chart2.clear(); // ✅ 避免重复实例化
      }

      const data = screenData.vendorStoreLocationCount;
      console.log(data);
      const gradients = {
        '艾奎': 'l(90) 0:#FF4966 1:#FFCFD6',
        // 从 #ff7f50 到 #ff4500 的线性渐变
        '久挚': 'l(90) 0:#FFDC38 1:#FFF4C3',
        '誉尊': 'l(90) 0:#99A2FF 1:#6A71E5',
        '经销商自采购': 'l(90) 0:#0091FF 1:#6DDDFF',
        '峰宁': 'l(90) 0:#ABFFBF 1:#48DC6B'
      };
      chart2.coordinate({
        type: 'theta',
        outerRadius: 0.8,
        innerRadius: 0.5
      });
      chart2.scale('color', {
        domain: Object.keys(gradients),
        range: Object.values(gradients)
      });
      chart2.coordinate({
        type: 'theta',
        outerRadius: 0.8,
        innerRadius: 0.5
      });
      chart2.options({
        clip: false,
        padding: [10, 100, 10, 100]
      });
      chart2.interval().data(data).transform({
        type: 'stackY'
      }).encode('y', 'storeLocationCount').encode('color', 'storeLocationVendorName') // 直接映射到渐变色
      .label({
        position: 'outside',
        text: d => `${d.storeLocationVendorName}: ${d.storeLocationCount}`,
        style: {
          fill: 'black',
          // 字体颜色
          fontSize: 10,
          // 字号（可选）
          fontWeight: 500 // 字重（可选）
        }
      }).legend(false).tooltip(false);
      try {
        chart2.render();
      } catch (e) {
        console.log(e);
      }
    };
    const renderChart3 = async () => {
      if (!chart3) {
        console.log('chart3走上');
        chart3 = initChart(propChart3.value);
      } else {
        console.log('chart3走下');
        chart3.clear(); // ✅ 避免重复实例化
      }

      const data = screenData.vendorStoreLocationCount;
      const gradients = {
        '艾奎': 'l(0) 0:#FF4966 1:#FFCFD6',
        '久挚': 'l(0) 0:#FFDC38 1:#FFF4C3',
        '誉尊': 'l(0) 0:#99A2FF 1:#6A71E5',
        '经销商自采购': 'l(0) 0:#0091FF 1:#6DDDFF',
        '峰宁': 'l(0) 0:#ABFFBF 1:#48DC6B'
      };

      // 给数据加一个 labelPos 字段，用于判断文字位置
      const dataWithLabelPos = data.map(d => ({
        ...d,
        labelPos: d.count < 10 ? 'right' : 'inside'
      }));
      chart3.coordinate({
        transpose: true
      });

      // 内部 label
      chart3.interval().data(dataWithLabelPos.filter(d => d.labelPos === 'inside')).encode('y', 'storeLocationCount').encode('x', 'storeLocationVendorName').encode('color', 'storeLocationVendorName').coordinate({
        transform: [{
          type: 'transpose'
        }]
      }).encode('size', [30]).scale('color', {
        domain: Object.keys(gradients),
        range: Object.values(gradients)
      }).label({
        text: 'storeLocationVendorName',
        position: 'inside',
        style: {
          fontSize: 12,
          fontWeight: 500,
          fill: '#000'
        }
      });

      // 外部 label
      chart3.interval().data(dataWithLabelPos.filter(d => d.labelPos === 'right')).encode('y', 'storeLocationCount').encode('x', 'storeLocationVendorName').encode('color', 'storeLocationVendorName').coordinate({
        transform: [{
          type: 'transpose'
        }]
      }).encode('size', [30]).label({
        text: 'item',
        position: 'right',
        style: {
          fontSize: 12,
          fontWeight: 500,
          fill: '#000'
        }
      });
      chart3.axis('y', {
        title: null,
        grid: true,
        labelFontSize: 10,
        title: null,
        gridStroke: "#000",
        // 修改颜色
        gridLineWidth: 1,
        gridLineDash: [0, 0]
      });
      chart3.axis('x', {
        title: null,
        label: false,
        // ✅ 隐藏 y 轴文字
        tickLine: false // 可选：隐藏刻度线
      });

      chart3.legend(false);
      try {
        chart3.render();
      } catch (e) {
        console.log(e);
      }
    };
    const renderChart4 = async () => {
      if (!chart4) {
        chart4 = initChart(screenChart1.value);
      } else {
        chart4.clear();
      }
      let rawData = screenData.dailyCountPing;
      console.log(rawData);

      // ✅ 转成长表格式
      let data = [];
      const metrics = ["onlineCount", "offlineCount", "failureCount", "disconnectCount", "totalCount"];
      rawData.forEach(d => {
        metrics.forEach(key => {
          data.push({
            date: new Date(d.screenStatSummaryDate),
            type: key,
            value: d[key]
          });
        });
      });
      console.log('data');
      console.log(data);
      chart4.data(data).encode("x", "date").encode("y", "value").encode("color", "type").scale("x", {
        type: "time",
        nice: true
      }).scale("y", {
        type: "linear",
        domain: [0, 2000]
      }).scale("color", {
        range: ["#4caf50", "#ff9800", "#f44336", "#999999", "#2196f3"] // ✅ 每条线不同颜色
      });

      // ✅ X轴显示日期
      chart4.axis("x", {
        autoRotate: false,
        // 禁止自动旋转
        grid: true,
        labelFontSize: 10,
        title: null,
        gridStroke: "#000",
        gridLineWidth: 1,
        gridLineDash: [0, 0],
        label: {
          autoRotate: false,
          rotate: 0,
          // 0度横排
          style: {
            textAlign: 'center',
            fontSize: 10
          }
        },
        labelFormatter: val => {
          const d = new Date(val);
          const year = d.getFullYear();
          const month = (d.getMonth() + 1).toString().padStart(2, '0'); // 补零
          return `${year}.${month}`;
        },
        style: {
          textAlign: 'center',
          // 可选，文字居中
          fontSize: 6
        }
      });

      // ✅ Y轴
      chart4.axis("y", {
        grid: true,
        label: {
          fontSize: 10
        },
        title: null
      });

      // ✅ 多折线
      chart4.line().encode("shape", "smooth") // 曲线，可改为 "line" 直线
      .style("lineWidth", 2).animate("enter", {
        type: "pathIn",
        duration: 800
      });

      // ✅ 每个点标注
      // chart4
      //   .point()
      //   .encode("shape", "circle")
      //   .style("fill", "#fff")
      //   .style("lineWidth", 1.5);

      // ✅ 自定义 tooltip，展示 activityData.videoTaskName
      chart4.interaction("tooltip", {
        render: (e, {
          title,
          items
        }) => {
          if (title.length == 19) {
            console.log(items);
            return `
              <div style="padding: 8px 12px; background: #fff; width:220px; font-size:12px;">
                <div style="margin-bottom: 6px; color:#909090;">${title.split(' ')[0]}</div>
                <div style="display: flex;justify-content: space-between;margin-bottom:6px;">
                  <div style="display:flex;align-items: center;">
                    <span style="display: inline-block;width: 5px;height: 5px;background: #056CFC;margin-right:5px;border-radius:50%"></span>
                    屏幕总数
                  </div>
                  <div>${items[0].value}</div>
                </div>
                <div style="display: flex;justify-content: space-between;margin-bottom:6px;">
                  <div style="display:flex;align-items: center;">
                    <span style="display: inline-block;width: 5px;height: 5px;background: #00CB08;margin-right:5px;border-radius:50%"></span>
                    在线数量
                  </div>
                  <div>${items[2].value}</div>
                </div>
                <div style="display: flex;justify-content: space-between;margin-bottom:6px;">
                  <div style="display:flex;align-items: center;">
                    <span style="display: inline-block;width: 5px;height: 5px;background: #FEBD30;margin-right:5px;border-radius:50%"></span>
                    离线数量
                  </div>
                  <div>${items[4].value}</div>
                </div>
                <div style="display: flex;justify-content: space-between;margin-bottom:6px;">
                  <div style="display:flex;align-items: center;">
                    <span style="display: inline-block;width: 5px;height: 5px;background: #FF6057;margin-right:5px;border-radius:50%"></span>
                    故障数量
                  </div>
                  <div>${items[3].value}</div>
                </div>
                <div style="display: flex;justify-content: space-between;margin-bottom:6px;">
                  <div style="display:flex;align-items: center;">
                    <span style="display: inline-block;width: 5px;height: 5px;background: #999999;margin-right:5px;border-radius:50%"></span>
                    未并网数量
                  </div>
                  <div>${items[1].value}</div>
                </div>
              </div>
            `;
          }
        }
      });
      chart4.legend(false);
      try {
        chart4.render();
      } catch (e) {
        console.error(e);
      }
    };

    // -----------------------

    // const renderChart4 = async () => {
    //   if (!chart4) {
    //     chart4 = initChart(screenChart1.value);
    //   } else {
    //     chart4.clear();
    //   }

    //   let rawData = screenData.dailyCountPing;

    //   // 转成长表格式（兼容你给出的两种数据形态）
    //   let data = [];
    //   const metrics = ["onlineCount", "offlineCount", "failureCount", "disconnectCount"];
    //   rawData.forEach((d) => {
    //     // 如果原数据已经是长表（{ date, type, value }），保持原样
    //     if (d.date && d.type && d.value !== undefined) {
    //       data.push({
    //         date: new Date(d.date),
    //         type: d.type,
    //         value: d.value,
    //       });
    //     } else {
    //       // 否则按你原来的短表转换逻辑（screenStatSummaryDate 为例）
    //       metrics.forEach((key) => {
    //         data.push({
    //           date: new Date(d.screenStatSummaryDate || d.date),
    //           type: key,
    //           value: d[key],
    //         });
    //       });
    //     }
    //   });

    //   // 确保按时间排序（有助于 domain 计算和渲染稳定）
    //   data.sort((a, b) => new Date(a.date) - new Date(b.date));

    //   // 计算 domain：如果所有数据在同一个月 -> 强制 domain = 当月 1 日 ~ 下月 1 日
    //   const dates = data.map((d) => (d.date instanceof Date ? d.date : new Date(d.date)));
    //   const minTs = Math.min(...dates.map(d => d.getTime()));
    //   const maxTs = Math.max(...dates.map(d => d.getTime()));
    //   const minDate = new Date(minTs);
    //   const maxDate = new Date(maxTs);

    //   let domainStart, domainEnd;
    //   const sameMonth = (minDate.getFullYear() === maxDate.getFullYear()) &&
    //                     (minDate.getMonth() === maxDate.getMonth());

    //   if (sameMonth) {
    //     domainStart = new Date(minDate.getFullYear(), minDate.getMonth(), 1).getTime();
    //     // 下个月第 1 天（确保显示“11月 - 12月”）
    //     domainEnd = new Date(minDate.getFullYear(), minDate.getMonth() + 1, 1).getTime();
    //   } else {
    //     // 给一点 padding（可选），这里直接用 min/max
    //     domainStart = minDate.getTime();
    //     domainEnd = maxDate.getTime();
    //   }

    //   // 赋数据并设置 scale/axis
    //   chart4
    //     .data(data)
    //     .encode("x", "date")
    //     .encode("y", "value")
    //     .encode("color", "type");

    //   // X 轴 scale：固定 domain，关闭 nice（避免自动再分割）
    //   chart4.scale("x", {
    //     type: "time",
    //     domain: [domainStart, domainEnd],
    //     nice: false,
    //     // 如果只同一个月，强制 tickCount 2；否则不强制（让图表自己决定）
    //     tickCount: sameMonth ? 2 : undefined,
    //   });

    //   // Y 轴 scale（保留你原来的）
    //   chart4.scale("y", {
    //     type: "linear",
    //     domain: [0, 2000],
    //   });

    //   chart4.scale("color", {
    //     range: ["#4caf50", "#ff9800", "#f44336", "#2196f3"],
    //   });

    //   // X 轴显示格式（两刻度时会显示当月和下月）
    //   chart4.axis("x", {
    //     autoRotate: false,
    //     grid: true,
    //     labelFontSize: 10,
    //     title: null,
    //     label: { autoRotate: false, rotate: 0, style: { textAlign: 'center', fontSize: 10 } },
    //     // 保证 tick 数量为 2 时也能正确格式化
    //     tickCount: sameMonth ? 2 : undefined,
    //     labelFormatter: (val) => {
    //       const d = new Date(val);
    //       const year = d.getFullYear();
    //       const month = (d.getMonth() + 1).toString().padStart(2, '0');
    //       return `${year}.${month}`;
    //     },
    //   });

    //   // ...后面保持你原有的 line/point/tooltip/legend/render 等配置
    //   chart4
    //     .line()
    //     .encode("shape", "smooth")
    //     .style("lineWidth", 2)
    //     .animate("enter", { type: "pathIn", duration: 800 });

    //   chart4.point().encode("shape", "circle").style("fill", "#fff").style("lineWidth", 1.5);

    //   // 你的 tooltip 渲染（不动）
    //   chart4.interaction("tooltip", {
    //     render: (e, { title, items }) => {
    //       if (title.length == 19) {
    //         // ...保持你原来返回的 html
    //       }
    //     },
    //   });

    //   chart4.legend(false);

    //   try {
    //     chart4.render();
    //   } catch (e) {
    //     console.error(e);
    //   }
    // };

    const renderChart5 = async () => {
      if (!chart5) {
        chart5 = initChart(screenChart2.value);
      } else {
        chart5.clear(); // ✅ 避免重复实例化
      }

      const data = screenData.pingStoreLocationCount;
      const gradients = {
        '半点': 'l(90) 0:#FF4966 1:#FFCFD6',
        // 从 #ff7f50 到 #ff4500 的线性渐变
        '策锐': 'l(90) 0:#FFDC38 1:#FFF4C3',
        '邑通': 'l(90) 0:#99A2FF 1:#6A71E5',
        '鑫臻': 'l(90) 0:#0091FF 1:#6DDDFF'
      };
      chart5.coordinate({
        type: 'theta',
        outerRadius: 0.8,
        innerRadius: 0.5
      });
      chart5.scale('color', {
        domain: Object.keys(gradients),
        range: Object.values(gradients)
      });
      console.log('chart5');
      console.log(data);
      chart5.interval().data(data).transform({
        type: 'stackY'
      }).encode('y', 'storeLocationCount').encode('color', 'storeLocationVendorName') // 直接映射到渐变色
      .label({
        position: 'outside',
        transform: [{
          type: 'overlapDodgeY' // 隐藏重叠标签
        }],

        text: d => `${d.storeLocationVendorName}: ${d.storeLocationCount}`,
        style: {
          fill: 'black',
          // 字体颜色
          fontSize: 10,
          // 字号（可选）
          fontWeight: 500,
          // 字重（可选）
          dy: 3,
          paddingLeft: '20px'
        },
        connector: {
          connectorDistance: 5
        }
      }).legend(false).tooltip(false);
      try {
        chart5.render();
      } catch (e) {
        console.log(e);
      }
    };
    const renderChart6 = async () => {
      if (!chart6) {
        chart6 = initChart(screenChart3.value);
      } else {
        chart6.clear(); // ✅ 避免重复实例化
      }

      const data = screenData.pingStoreLocationCount;
      const gradients = {
        '半点': 'l(0) 0:#FF4966 1:#FFCFD6',
        '策锐': 'l(0) 0:#FFDC38 1:#FFF4C3',
        '邑通': 'l(0) 0:#99A2FF 1:#6A71E5',
        '鑫臻': 'l(0) 0:#0091FF 1:#6DDDFF'
      };

      // 给数据加一个 labelPos 字段，用于判断文字位置
      const dataWithLabelPos = data.map(d => ({
        ...d,
        labelPos: d.count < 10 ? 'right' : 'inside'
      }));
      chart6.coordinate({
        transpose: true
      });

      // 内部 label
      chart6.interval().data(dataWithLabelPos.filter(d => d.labelPos === 'inside')).encode('y', 'storeLocationCount').encode('x', 'storeLocationVendorName').encode('color', 'storeLocationVendorName').coordinate({
        transform: [{
          type: 'transpose'
        }]
      }).encode('size', [30]).scale('color', {
        domain: Object.keys(gradients),
        range: Object.values(gradients)
      }).label({
        text: 'storeLocationVendorName',
        position: 'inside',
        style: {
          fontSize: 12,
          fontWeight: 500,
          fill: '#000'
        }
      });

      // 外部 label
      chart6.interval().data(dataWithLabelPos.filter(d => d.labelPos === 'right')).encode('y', 'storeLocationCount').encode('x', 'storeLocationVendorName').encode('color', 'storeLocationVendorName').coordinate({
        transform: [{
          type: 'transpose'
        }]
      }).encode('size', [30]).label({
        text: 'item',
        position: 'right',
        style: {
          fontSize: 12,
          fontWeight: 500,
          fill: '#000'
        }
      });
      chart6.axis('y', {
        title: null,
        grid: true,
        labelFontSize: 10,
        title: null,
        gridStroke: "#000",
        // 修改颜色
        gridLineWidth: 1,
        gridLineDash: [0, 0]
      });
      chart6.axis('x', {
        title: null,
        label: false,
        // ✅ 隐藏 y 轴文字
        tickLine: false // 可选：隐藏刻度线
      });

      chart6.legend(false);
      try {
        chart6.render();
      } catch (e) {
        console.log(e);
      }
    };
    const tabsChange = async key => {
      console.log('tabsChange' + key);
      segmentedValue.value = 'view';
      chartValue.value = 'pie';
      uploadFilePopoverVisible.value = false;
      uploadFilePopoverVisible1.value = false;
      nextTick(async () => {
        if (key == '1') {
          // 如果你是每次都重新渲染，那保留原逻辑
          await renderChart1();
          await renderChart2();
          await renderChart3();
        } else if (key == '2') {
          console.log(222222222222222);
          await renderChart4();
          await renderChart5();
          await renderChart6();
        } else {
          // 其他 tab 的逻辑
        }
      });
    };
    const chartTabChangeLeft = async (val, num) => {
      // 延迟到下一帧，等 DOM 渲染完再触发
      nextTick(() => {
        if (val === 'pie') {
          renderChart2();
        } else if (val === 'bar') {
          renderChart3();
        }
      });
    };
    const chartTabChangeRight = async (val, num) => {
      // 延迟到下一帧，等 DOM 渲染完再触发
      nextTick(() => {
        if (val === 'pie') {
          renderChart5();
        } else if (val === 'bar') {
          renderChart6();
        }
      });
    };
    const storeData = reactive({
      paginationData: {
        pageSizes: [25, 50, 75, 100],
        currentPage: 1,
        totalSize: 0,
        pageSize: 25
      }
    });
    const storeData2 = reactive({
      paginationData: {
        pageSizes: [25, 50, 75, 100],
        currentPage: 1,
        totalSize: 0,
        pageSize: 25
      }
    });
    const formatTimestamp = ts => {
      return dayjs(ts).format('YYYY-MM-DD HH:mm:ss');
    };
    const onStatsSearch = async () => {
      let scrollWrapper = storeTable.value.$el.querySelector('.vxe-table--body-wrapper');
      if (scrollWrapper) {
        scrollWrapper.scrollTop = 0;
      }
      storeData.paginationData.currentPage = 1;
      let getScreenByPageMsg = await getScreenByPage();
      screenData.screenList = getScreenByPageMsg.pageList;
    };
    const onStatsSearch2 = async () => {
      let scrollWrapper = storeTable2.value.$el.querySelector('.vxe-table--body-wrapper');
      if (scrollWrapper) {
        scrollWrapper.scrollTop = 0;
      }
      storeData2.paginationData.currentPage = 1;
      let getScreenByPageMsg = await getScreenByPage2();
      screenData.screenList2 = getScreenByPageMsg.pageList;
    };
    const getScreenDeviceTypeDict = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.screenRequest.getScreenDeviceTypeDict(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const statusClick = async type => {
      segmentedValue.value = 'list';
      deviceOnlineStatus.value = type;
      let scrollWrapper = storeTable2.value.$el.querySelector('.vxe-table--body-wrapper');
      if (scrollWrapper) {
        scrollWrapper.scrollTop = 0;
      }
      storeData2.paginationData.currentPage = 1;
      let getScreenByPageMsg = await getScreenByPage2();
      screenData.screenList2 = getScreenByPageMsg.pageList;
    };
    const getStoreTypeDict = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.screenRequest.getStoreTypeDict(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getVendorTypeVendor = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.vendorRequest.getVendorTypeVendor(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getScreenByPage = async () => {
      storeLoading.value = true;
      let screenPageROPageInfo = {
        data: {
          searchKeyword: searchKeyword.value,
          storeTypes: screenData.storeTypeIds.length == 0 ? null : screenData.storeTypeIds,
          storeLocationVendorTypeId: 2
        },
        pageIndex: storeData.paginationData.currentPage,
        pageSize: storeData.paginationData.pageSize
      };
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreLocationInfo(screenPageROPageInfo, true).then(res => {
          if (res.code === '200000') {
            if (res.result.dataCode === '202513') {
              storeData.paginationData.totalSize = res.result.data.totalCount;
              if (res.result.data.totalCount == 0) {
                res.result.data.pageList = [];
                resolve(res.result.data);
              } else {
                resolve(res.result.data);
              }
              storeLoading.value = false;
            }
          } else {
            ElNotification({
              title: "error",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getScreenByPagePush = async () => {
      storeLoading.value = true;
      let screenPageROPageInfo = {
        data: {
          searchKeyword: searchKeyword.value,
          storeTypes: screenData.storeTypeIds.length == 0 ? null : screenData.storeTypeIds,
          storeLocationVendorTypeId: 2
        },
        pageIndex: storeData.paginationData.currentPage,
        pageSize: storeData.paginationData.pageSize
      };
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreLocationInfo(screenPageROPageInfo, true).then(res => {
          if (res.code === '200000') {
            if (res.result.dataCode === '202513') {
              storeData.paginationData.totalSize = res.result.data.totalCount;
              if (res.result.data.totalCount == 0) {
                res.result.data.pageList = [];
                resolve(res.result.data);
              } else {
                resolve(res.result.data);
              }
              storeLoading.value = false;
            }
          } else {
            ElNotification({
              title: "error",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getScreenByPage2 = async () => {
      storeLoading.value = true;
      let screenPageROPageInfo = {
        data: {
          searchKeyword: searchKeyword2.value,
          storeTypes: screenData.storeTypeIds2.length == 0 ? null : screenData.storeTypeIds2,
          venderId: screenData.venderId2,
          storeLocationVendorTypeId: 3,
          deviceOnlineStatus: deviceOnlineStatus.value ? deviceOnlineStatus.value : null
        },
        pageIndex: storeData2.paginationData.currentPage,
        pageSize: storeData2.paginationData.pageSize
      };
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreLocationInfo(screenPageROPageInfo, true).then(res => {
          if (res.code === '200000') {
            if (res.result.dataCode === '202513') {
              storeData2.paginationData.totalSize = res.result.data.totalCount;
              if (res.result.data.totalCount == 0) {
                res.result.data.pageList = [];
                resolve(res.result.data);
              } else {
                resolve(res.result.data);
              }
              storeLoading.value = false;
            }
          } else {
            ElNotification({
              title: "error",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getScreenByPagePush2 = async () => {
      storeLoading.value = true;
      let screenPageROPageInfo = {
        data: {
          searchKeyword: searchKeyword2.value,
          storeTypes: screenData.storeTypeIds2.length == 0 ? null : screenData.storeTypeIds2,
          venderId: screenData.venderId2,
          storeLocationVendorTypeId: 3,
          deviceOnlineStatus: deviceOnlineStatus.value ? deviceOnlineStatus.value : null
        },
        pageIndex: storeData2.paginationData.currentPage,
        pageSize: storeData2.paginationData.pageSize
      };
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreLocationInfo(screenPageROPageInfo, true).then(res => {
          if (res.code === '200000') {
            if (res.result.dataCode === '202513') {
              storeData2.paginationData.totalSize = res.result.data.totalCount;
              if (res.result.data.totalCount == 0) {
                res.result.data.pageList = [];
                resolve(res.result.data);
              } else {
                resolve(res.result.data);
              }
              storeLoading.value = false;
            }
          } else {
            ElNotification({
              title: "error",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const showModal = data => {
      console.log(data);
      open.value = true;
      imageList.value = data;
    };
    const headerCellClickEvent = ({
      column,
      triggerResizable,
      triggerSort,
      triggerFilter
    }) => {
      const $table = storeTable.value;
      if ($table) {
        if (column.sortable && !(triggerResizable || triggerSort || triggerFilter)) {
          if (column.order === "desc") {
            $table.clearSort();
          } else if (column.order === "asc") {
            $table.sort(column.field, "desc");
          } else {
            $table.sort(column.field, "asc");
          }
        }
      }
    };
    const headerCellClickEvent2 = ({
      column,
      triggerResizable,
      triggerSort,
      triggerFilter
    }) => {
      const $table = storeTable2.value;
      if ($table) {
        if (column.sortable && !(triggerResizable || triggerSort || triggerFilter)) {
          if (column.order === "desc") {
            $table.clearSort();
          } else if (column.order === "asc") {
            $table.sort(column.field, "desc");
          } else {
            $table.sort(column.field, "asc");
          }
        }
      }
    };
    const getScreenDeviceStat = async screenDeviceStatRO => {
      return new Promise((resolve, reject) => {
        proxy.$api.screenRequest.getScreenDeviceStat(screenDeviceStatRO).then(res => {
          if (res.code === '200000') {
            resolve(res.result.data);
          } else {
            ElNotification({
              title: "error",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const checkScrollBottom = debounce(async () => {
      if (!storeTable.value) return;
      const scrollWrapper = storeTable.value.$el.querySelector('.vxe-table--body-wrapper');
      if (!scrollWrapper) return;
      const {
        scrollTop,
        scrollHeight,
        clientHeight
      } = scrollWrapper;
      const isBottom = scrollHeight - scrollTop <= clientHeight + 20;
      if (isBottom && !storeLoading.value) {
        console.log('isBottom');
        let num = Math.ceil(storeData.paginationData.totalSize / storeData.paginationData.pageSize);
        if (num === storeData.paginationData.currentPage) {
          console.log('bottom');
          return;
        }
        storeData.paginationData.currentPage += 1;
        let getScreenByPageMsg = await getScreenByPagePush();
        if (getScreenByPageMsg.pageList.length == 0) {
          storeData.paginationData.currentPage -= 1;
          return;
        } else {
          screenData.screenList.push(...getScreenByPageMsg.pageList);
        }
      }
    }, 300);
    const checkScrollBottom2 = debounce(async () => {
      if (!storeTable2.value) return;
      const scrollWrapper = storeTable2.value.$el.querySelector('.vxe-table--body-wrapper');
      if (!scrollWrapper) return;
      const {
        scrollTop,
        scrollHeight,
        clientHeight
      } = scrollWrapper;
      const isBottom = scrollHeight - scrollTop <= clientHeight + 20;
      if (isBottom && !storeLoading.value) {
        console.log('isBottom');
        let num = Math.ceil(storeData2.paginationData.totalSize / storeData2.paginationData.pageSize);
        if (num === storeData2.paginationData.currentPage) {
          console.log('bottom');
          return;
        }
        storeData2.paginationData.currentPage += 1;
        let getScreenByPageMsg = await getScreenByPagePush2();
        if (getScreenByPageMsg.pageList.length == 0) {
          storeData2.paginationData.currentPage -= 1;
          return;
        } else {
          screenData.screenList2.push(...getScreenByPageMsg.pageList);
        }
      }
    }, 300);
    const handleScroll = () => {
      checkScrollBottom();
    };
    const handleScroll2 = () => {
      checkScrollBottom2();
    };
    const storeClickEvent = row => {
      const url = `/store-location/${row.storeCode}/${row.storeLocationId}?isScreen=2`;
      window.open(url, "_blank"); // _blank 表示新窗口/新标签页
    };

    const storeClickEvent2 = row => {
      const url = `/store-location/${row.storeCode}/${row.storeLocationId}?isScreen=2`;
      window.open(url, "_blank"); // _blank 表示新窗口/新标签页
    };

    const onCheckAllChange = e => {
      const checked = e.target.checked;
      screenData.storeTypeIds = checked ? screenData.screenTypeList.map(item => item.storeTypeId) : [];
      updateCheckAllStatus();
    };
    const onCheckAllChange2 = e => {
      const checked = e.target.checked;
      screenData.storeTypeIds2 = checked ? screenData.screenTypeList.map(item => item.storeTypeId) : [];
      updateCheckAllStatus2();
    };
    const updateCheckAllStatus = async () => {
      const totalOptions = screenData.screenTypeList.length;
      const selectedLength = screenData.storeTypeIds.length;
      checkAll.value = selectedLength === totalOptions;
      screenData.indeterminate = selectedLength > 0 && selectedLength < totalOptions;
      let scrollWrapper = storeTable.value.$el.querySelector('.vxe-table--body-wrapper');
      if (scrollWrapper) {
        scrollWrapper.scrollTop = 0;
      }
      storeData.paginationData.currentPage = 1;
      let getScreenByPageMsg = await getScreenByPage();
      screenData.screenList = getScreenByPageMsg.pageList;
    };
    const updateCheckAllStatus2 = async () => {
      const totalOptions = screenData.screenTypeList.length;
      const selectedLength = screenData.storeTypeIds2.length;
      checkAll2.value = selectedLength === totalOptions;
      screenData.indeterminate2 = selectedLength > 0 && selectedLength < totalOptions;
      let scrollWrapper = storeTable2.value.$el.querySelector('.vxe-table--body-wrapper');
      if (scrollWrapper) {
        scrollWrapper.scrollTop = 0;
      }
      storeData2.paginationData.currentPage = 1;
      let getScreenByPageMsg = await getScreenByPage2();
      screenData.screenList2 = getScreenByPageMsg.pageList;
    };
    const onVendorChange2 = async () => {
      let scrollWrapper = storeTable2.value.$el.querySelector('.vxe-table--body-wrapper');
      if (scrollWrapper) {
        scrollWrapper.scrollTop = 0;
      }
      storeData2.paginationData.currentPage = 1;
      let getScreenByPageMsg = await getScreenByPage2();
      screenData.screenList2 = getScreenByPageMsg.pageList;
    };
    const onCheckboxChange = (storeTypeId, e) => {
      const checked = e.target.checked;
      const selected = screenData.storeTypeIds.slice();
      console.log(storeTypeId, e.target.checked);
      if (checked) {
        selected.push(storeTypeId);
      } else {
        const index = selected.indexOf(storeTypeId);
        if (index > -1) {
          selected.splice(index, 1);
        }
      }
      screenData.storeTypeIds = selected;
      updateCheckAllStatus();
    };
    const onCheckboxChange2 = (storeTypeId, e) => {
      const checked = e.target.checked;
      const selected = screenData.storeTypeIds2.slice();
      console.log(storeTypeId, e.target.checked);
      if (checked) {
        selected.push(storeTypeId);
      } else {
        const index = selected.indexOf(storeTypeId);
        if (index > -1) {
          selected.splice(index, 1);
        }
      }
      screenData.storeTypeIds2 = selected;
      updateCheckAllStatus2();
    };
    const rowClassName = row => {
      if (row.row.deviceOnlineStatus === 1) {
        return "borderLeftGreen";
      } else if (row.row.deviceOnlineStatus === 2) {
        return "borderLeftYellow";
      } else if (row.row.deviceOnlineStatus === 3) {
        return "borderLeftGray";
      } else if (row.row.deviceOnlineStatus === 4) {
        return "borderLeftRed";
      }
    };
    const onRangeChange = async a => {
      if (a != null) {
        //道具条形图
        let ddddata = {
          startDate: dateValue.value[0],
          endDate: dateValue.value[1]
        };
        let getDailyCountMsg = await getDailyCount(ddddata, true);
        if (getDailyCountMsg == null) {
          return;
        }
        getDailyCountMsg.sort((a, b) => new Date(a.videoTaskBeginDate) - new Date(b.videoTaskBeginDate));
        screenData.dailyCount = getDailyCountMsg;
        await nextTick();
        await renderChart1();
      }
    };
    const onRangeChange2 = async a => {
      if (a != null) {
        //屏幕条形图
        let data = {
          startDate: dateValue2.value[0],
          endDate: dateValue2.value[1]
        };
        let getPingCountMsg = await getScreenDailyCount(data, true);
        if (getPingCountMsg == null) {
          return;
        }
        getPingCountMsg.sort((a, b) => new Date(a.videoTaskBeginDate) - new Date(b.videoTaskBeginDate));
        await nextTick();
        await renderChart4();
      }
    };
    //测试接口
    const getScreenVendorData = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.screenRequest.getScreenVendorData().then(res => {
          if (res.code === '200000') {
            resolve(res.result.data);
          } else {
            ElNotification({
              title: "error",
              message: res.msg,
              type: "error",
              duration: 3000
            });
            resolve(null);
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    //道具屏幕总数
    const getStoreLocationCount = async id => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreLocationCount(id, true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    //条形图数据
    const getDailyCount = async resRo => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getDailyCount(resRo).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    //列表
    const getVendorStoreLocationCount = async resRo => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getVendorStoreLocationCount(resRo).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    //列表
    const addFailScreenReason = async resRo => {
      return new Promise((resolve, reject) => {
        proxy.$api.screenRequest.addFailScreenReason(resRo).then(res => {
          if (res.result.dataCode == "202522") {
            ElNotification({
              title: t("activityDetail.success"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
            resolve(res.result.data);
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };

    //屏幕条形图
    const getScreenDailyCount = async resRo => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getScreenDailyCount(resRo).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };

    //屏幕供应商在线数量
    const getScreeTodayCount = async resRo => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getScreeTodayCount(resRo).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    onMounted(async () => {
      // let arr = await getScreenVendorData()
      // console.log(arr)
      // let screenDeviceTypeDict = await getScreenDeviceTypeDict();
      // if (screenDeviceTypeDict == null) {
      //   return;
      // }
      // screenData.screenType.push(...screenDeviceTypeDict)
      let getStoreTypeDictMsg = await getStoreTypeDict();
      if (getStoreTypeDictMsg == null) {
        return;
      }
      screenData.screenTypeList.push(...getStoreTypeDictMsg);
      let screenVendorList = await getScreenVendorData();
      if (screenVendorList == null) {
        return;
      }
      screenData.screenVendorList.push(...screenVendorList.map(item => ({
        vendorId: item.storeLocationVendorId,
        vendorName: item.storeLocationVendorName
      })));
      let getScreenByPageMsg = await getScreenByPage();
      if (getScreenByPageMsg.pageList.length == 0) {
        return;
      }
      screenData.screenList.length = 0;
      screenData.screenList = getScreenByPageMsg.pageList;
      screenData.storeTypeIds = screenData.screenTypeList.map(item => item.storeTypeId);
      let getScreenByPageMsg2 = await getScreenByPage2();
      if (getScreenByPageMsg2.pageList.length == 0) {
        return;
      }
      screenData.screenList2.length = 0;
      screenData.screenList2 = getScreenByPageMsg2.pageList;
      screenData.storeTypeIds2 = screenData.screenTypeList.map(item => item.storeTypeId);
      //当前年月-12
      const currentDate = new Date();
      const twelveMonthsAgoDate = new Date(currentDate);
      twelveMonthsAgoDate.setMonth(twelveMonthsAgoDate.getMonth() - 12);

      // 转换为 YYYY-MM-DD 格式
      const currentDateStr = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}`;
      const twelveMonthsAgoDateStr = `${twelveMonthsAgoDate.getFullYear()}-${String(twelveMonthsAgoDate.getMonth() + 1).padStart(2, '0')}-${String(twelveMonthsAgoDate.getDate()).padStart(2, '0')}`;

      // 设置日期选择器的值
      dateValue.value = [twelveMonthsAgoDateStr, currentDateStr];
      dateValue2.value = [twelveMonthsAgoDateStr, currentDateStr];
      //道具总数
      let getScreenDeviceStatMsg = await getStoreLocationCount({
        storeLocationVendorTypeId: 2
      });
      if (getScreenDeviceStatMsg == null) {
        return;
      }
      screenData.storeLocationCount = getScreenDeviceStatMsg;
      //道具条形图
      let ddddata = {
        startDate: dateValue.value[0],
        endDate: dateValue.value[1]
      };
      let getDailyCountMsg = await getDailyCount(ddddata, true);
      if (getDailyCountMsg == null) {
        return;
      }
      getDailyCountMsg.sort((a, b) => new Date(a.videoTaskBeginDate) - new Date(b.videoTaskBeginDate));
      screenData.dailyCount = getDailyCountMsg;
      //道具柱状图
      let vendorStoreLocationCountMsg = await getVendorStoreLocationCount({
        storeLocationVendorTypeId: 2
      });
      if (vendorStoreLocationCountMsg == null) {
        return;
      }
      vendorStoreLocationCountMsg.sort((a, b) => b.storeLocationCount - a.storeLocationCount);
      screenData.vendorStoreLocationCount = vendorStoreLocationCountMsg;

      //屏幕总数
      let getScreenDeviceStatMsg1 = await getScreeTodayCount(true);
      if (getScreenDeviceStatMsg1 == null) {
        return;
      } else {
        getScreenDeviceStatMsg1.totalCount = getScreenDeviceStatMsg1.disconnectCount + getScreenDeviceStatMsg1.failureCount + getScreenDeviceStatMsg1.offlineCount + getScreenDeviceStatMsg1.onlineCount;
      }
      screenData.storeLocationCountPing = getScreenDeviceStatMsg1;

      //屏幕条形图
      let data = {
        startDate: dateValue2.value[0],
        endDate: dateValue2.value[1]
      };
      let getPingCountMsg = await getScreenDailyCount(data, true);
      if (getPingCountMsg == null) {
        return;
      }
      getPingCountMsg.forEach(d => {
        d.totalCount = d.onlineCount + d.offlineCount + d.failureCount + d.disconnectCount;
      });
      getPingCountMsg.sort((a, b) => new Date(a.videoTaskBeginDate) - new Date(b.videoTaskBeginDate));
      screenData.dailyCountPing = getPingCountMsg;

      //屏幕柱状图
      let pingStoreLocationCountMsg = await getVendorStoreLocationCount({
        storeLocationVendorTypeId: 3
      });
      if (pingStoreLocationCountMsg == null) {
        return;
      }
      pingStoreLocationCountMsg.sort((a, b) => b.storeLocationCount - a.storeLocationCount);
      screenData.pingStoreLocationCount = pingStoreLocationCountMsg;

      // await nextTick();
      // await renderChart1();
      // await renderChart2();
      // await renderChart3();
      if (isScreen == 2) {
        activeKey.value = '2';
      } else {
        activeKey.value = '1';
      }
      console.log('activeKey.value');
      console.log(activeKey.value);
      tabsChange(activeKey.value);
    });
    const exportTaskModelClick = index => {
      getStoreLocationInfoExport(index);
    };
    const downLoadTaskModelClick = index => {
      getScreenVenderExport();
    };
    const getStoreLocationInfoExport = async index => {
      let screenPageROPageInfo = {};
      if (index == 2) {
        screenPageROPageInfo = {
          storeLocationVendorTypeId: index
        };
      } else {
        screenPageROPageInfo = {
          searchKeyword: searchKeyword2.value,
          storeTypes: screenData.storeTypeIds2.length == 0 ? null : screenData.storeTypeIds2,
          venderId: screenData.venderId2,
          storeLocationVendorTypeId: 3,
          deviceOnlineStatus: deviceOnlineStatus.value ? deviceOnlineStatus.value : null
        };
      }
      const loadingInstance = ElLoading.service({
        lock: true,
        text: t("activityDetail.exportingTemplate"),
        background: "rgba(0, 0, 0, 0.7)"
      });
      proxy.$api.storeRequest.getStoreLocationInfoExport(screenPageROPageInfo).then(res => {
        nextTick(() => {
          loadingInstance.close();
        });
      }).catch(error => {
        ElNotification({
          title: t("activityDetail.error"),
          message: error,
          type: "error",
          duration: 3000
        });
        nextTick(() => {
          loadingInstance.close();
        });
      });
    };
    const getScreenVenderExport = async () => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: t("activityDetail.exportingTemplate"),
        background: "rgba(0, 0, 0, 0.7)"
      });
      proxy.$api.storeRequest.getScreenVenderExport().then(res => {
        console.log(res);
        nextTick(() => {
          loadingInstance.close();
        });
      }).catch(error => {
        ElNotification({
          title: t("activityDetail.error"),
          message: error,
          type: "error",
          duration: 3000
        });
        nextTick(() => {
          loadingInstance.close();
        });
      });
    };
    const uploadFile = ref(null);
    const uploadFileData = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      cacheData: []
    });
    const openUploadFilePopover = () => {
      uploadFile.value.clearFiles();
      uploadFilePopoverVisible.value = true;
    };
    const openUploadFilePopover1 = () => {
      uploadFile.value.clearFiles();
      uploadFilePopoverVisible1.value = true;
    };
    const handleFileExceed = files => {
      uploadFile.value.clearFiles();
      const file = files[0];
      file.uid = genFileId();
      uploadFile.value.handleStart(file);
      uploadFile.value.submit();
    };
    const handleFileOnSuccess = async (response, file, files) => {
      console.log(file.status);
      if (file.status === "success") {
        console.log('success');
        let activityUploadedRO = {
          uploadedRO: {
            fileName: uploadFileData.data.name,
            uploadedName: uploadFileData.data.key
          }
        };
        uploadFileRequest(activityUploadedRO);
      }
    };
    const getSignature = async directory => {
      return new Promise((resolve, reject) => {
        proxy.$api.authorizationRequest.getSignature(directory).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
      });
    };
    const handleFileBeforeUpload = async file => {
      console.log(file);
      uploadFileData.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadFileData.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadFileData.signatureData.dir + fullName;
      uploadFileData.data = {
        name: file.name,
        key: keyValue,
        policy: uploadFileData.signatureData.policy,
        OSSAccessKeyId: uploadFileData.signatureData.accessId,
        signature: uploadFileData.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid
      };
      uploadFileData.lastUpload = {
        uid: file.uid,
        filename: fullName
      };
    };
    const uploadFileRequest = async activityUploadedRO => {
      uploadFilePopoverVisible.value = true;
      uploadFilePopoverVisible1.value = true;
      storeLoading.value = true;
      proxy.$api.activityRequest.importScreenVenderStoreLocation(activityUploadedRO).then(async res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202520") {
            storeData2.paginationData.currentPage = 1;
            let getScreenByPageMsg = await getScreenByPage2();
            screenData.screenList2 = getScreenByPageMsg.pageList;
            uploadFilePopoverVisible.value = false;
            uploadFilePopoverVisible1.value = false;
            storeLoading.value = false;
            ElNotification({
              title: t("activityDetail.success"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
          } else {
            ElNotification({
              title: t("activityDetail.fail"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
            uploadFilePopoverVisible.value = false;
            uploadFilePopoverVisible1.value = false;
            storeLoading.value = false;
          }
        } else {
          ElNotification({
            title: t("activityDetail.fail"),
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: t("activityDetail.error"),
            message: error,
            type: "error",
            duration: 3000
          });
        }
        uploadFilePopoverVisible.value = false;
        uploadFilePopoverVisible1.value = false;
        storeLoading.value = false;
      });
    };
    const editClosedEvent = async ({
      row,
      column
    }) => {
      console.log('修改后的值：', row.failReason);
      console.log(row.storeLocationId);
      if (row.failReason != null) {
        let data = {
          storeLocationId: row.storeLocationId,
          failReason: row.failReason == "" ? null : row.failReason
        };
        let res = await addFailScreenReason(data);
        console.log(res);
      }
    };
    const beforeEditMethod = ({
      row,
      column
    }) => {
      console.log(row.deviceOnlineStatus);
      // 只限制 storeCode 这一列
      if (column.field === 'failReason') {
        return row.deviceOnlineStatus == 4;
      }
    };
    return {
      editClosedEvent,
      beforeEditMethod,
      handleFileBeforeUpload,
      uploadFile,
      uploadFileData,
      openUploadFilePopover,
      openUploadFilePopover1,
      handleFileExceed,
      handleFileOnSuccess,
      statusClick,
      exportTaskModelClick,
      activeKey,
      searchKeyword,
      searchKeyword2,
      onStatsSearch,
      onStatsSearch2,
      storeData,
      storeData2,
      screenData,
      headerCellClickEvent,
      headerCellClickEvent2,
      storeTable,
      storeTable2,
      open,
      showModal,
      storeLoading,
      handleScroll,
      handleScroll2,
      imageList,
      formatTimestamp,
      currentYearMonth,
      sixMonthsAgoYearMonth,
      storeClickEvent,
      storeClickEvent2,
      checkAll,
      checkAll2,
      onCheckAllChange,
      onCheckAllChange2,
      onVendorChange2,
      onCheckboxChange,
      onCheckboxChange2,
      rowClassName,
      segmentedData,
      segmentedValue,
      dateValue,
      dateValue2,
      chartData,
      chartValue,
      chartTabChangeRight,
      chartTabChangeLeft,
      tabsChange,
      propChart1,
      propChart2,
      propChart3,
      screenChart1,
      screenChart2,
      screenChart3,
      onRangeChange,
      onRangeChange2,
      deviceOnlineStatus,
      downLoadTaskModelClick,
      uploadFilePopoverVisible,
      uploadFilePopoverVisible1
    };
  }
};